import { SERVER_ROLES } from '../components/ProjectServerRoles';

/** Unique server IDs assigned via infra roles or proyecto_servidor links. */
export function collectDirectServerIds(proyecto) {
  if (!proyecto) return [];
  const ids = new Set();
  SERVER_ROLES.forEach(({ key }) => {
    const n = parseInt(proyecto[key], 10);
    if (n > 0) ids.add(n);
  });
  (proyecto.servidores || []).forEach((row) => {
    const n = parseInt(row.servidor_id, 10);
    if (n > 0) ids.add(n);
  });
  return [...ids].sort((a, b) => a - b);
}

export function buildDirectServerRows(proyecto, allServers = []) {
  const byId = Object.fromEntries(allServers.map((s) => [Number(s.id), s]));
  const rolesByServer = {};
  SERVER_ROLES.forEach(({ key, label }) => {
    const sid = parseInt(proyecto[key], 10);
    if (sid > 0) {
      if (!rolesByServer[sid]) rolesByServer[sid] = [];
      rolesByServer[sid].push(label);
    }
  });
  (proyecto.servidores || []).forEach((row) => {
    const sid = parseInt(row.servidor_id, 10);
    if (sid > 0) {
      if (!rolesByServer[sid]) rolesByServer[sid] = [];
      const tag = row.rol ? `asoc: ${row.rol}` : 'asociado';
      if (!rolesByServer[sid].includes(tag)) rolesByServer[sid].push(tag);
    }
  });

  return collectDirectServerIds(proyecto).map((id) => {
    const live = byId[id];
    const nameKey = SERVER_ROLES.find((r) => parseInt(proyecto[r.key], 10) === id)?.key.replace('_id', '_nombre');
    const ipKey = nameKey?.replace('_nombre', '_ip');
    return {
      id,
      nombre: live?.nombre || proyecto[nameKey] || `Servidor #${id}`,
      ip: (live?.ip || proyecto[ipKey] || '').trim(),
      carga: live?.carga ?? '—',
      ram: live?.ram ?? '—',
      espaciolibre: live?.espaciolibre ?? '—',
      roles: rolesByServer[id]?.join(', ') || '—',
    };
  });
}
